import { useEffect, useRef } from "react";
import { metricsBus } from "@/common/buses";
import { getEventDevice } from "@/common/utils/device";
import { isEmbedPath, isEmbedReferral, isGridTargetPath } from "@/common/utils/routes";

const FRESH_TAB_HISTORY_LENGTH = 1;

const isPrerendering = () => Boolean((document as Document & { prerendering?: boolean }).prerendering);

const isFreshTab = () => window.history.length === FRESH_TAB_HISTORY_LENGTH;

const isOpenedFromFeed = () => {
  const [entry] = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];

  if (entry?.type !== "navigate" || !document.referrer) {
    return false;
  }

  try {
    const referrer = new URL(document.referrer);

    if (referrer.origin !== window.location.origin) {
      return false;
    }

    return !isEmbedPath(referrer.pathname);
  } catch {
    return false;
  }
};

export const useTrackNewTabOpen = () => {
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current || isPrerendering()) {
      return;
    }

    const { pathname, search } = window.location;

    if (!isFreshTab() || !isOpenedFromFeed() || isEmbedReferral(search) || !isGridTargetPath(pathname, search)) {
      return;
    }

    sentRef.current = true;
    metricsBus.emit("pageNewTabOpened", { device: getEventDevice() });
  }, []);
};
